import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _FunctionalID, _NoveltyAccount, _OutputAuthorizationRequest, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { SelectIDWorkGroupBPMSingleton } from "../../../../../admin/select/SelectIDWorkGroupBPMSingleton";
import { StepWizard, Wizard } from "../../../../config/Componentes/wizard/Wizard";
import { SOLAUTOutputAuthorizationItem } from "./Componentes/SOLAUTOutputAuthorizationItem";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

type listaPropsLength = {
    product: number;
    fixed: number;

}

export const SOLAUTSAL001 = ({ configProcedure }: Props) => {

    const { instance, addRequiredFields, validateForm, isMissing, bean, setBean } = useDataBean(_OutputAuthorizationRequest);
    const { instance: instanceArea } = useDataBean(_FunctionalID);

    const props = configProcedure?._pocessData?.Props ?? {};
    const procedure = configProcedure?._procedure ?? {};
    const myGroups: any[] = _single.getMyGroupsBPM() ?? [];
    const [selectedArea, setSelectedArea] = useState<any>(null);

    const [lengthList, setLengthList] = useState<Partial<listaPropsLength>>({})

    useEffect(() => {
        if (myGroups.length === 1) {
            setSelectedArea(myGroups[0].DataBeanProperties);
        }
    }, [myGroups]);

    useEffect(() => {
        if (!props) return;

        const group = props.IDWorkGroupMember ? myGroups.find(g => g.IDWorkGroupMember === props.IDWorkGroupMember) : (myGroups.length === 1 ? myGroups[0] : null);

        if (group) {
            setSelectedArea(group);
        }

        setBean({
            IDOutputAuthorizationRequest: props.IDOutputAuthorizationRequest ?? null,
            FromDate: props.FromDate ?? _single.getCurrenDate(),
            UptoDate: props.UptoDate ?? _single.getCurrenDate(),
            State: 100,
            IDEmployee: _single.getAccountID(),
            IDProcedureIMP: procedure?.IDProcedureImp,
            Description: props.Description ?? "",

            IDWorkGroupMember: group?.IDWorkGroupMember ?? null,
            FunctionalIDLn: group?.IDLn ?? null,
            IDOffice: group?.IDOffice ?? null,
        });

    }, [props, myGroups]);

    useEffect(() => {
        addRequiredFields(["FromDate", "UptoDate", "IDWorkGroupMember"]);
    }, []);

    const onExportMap = () => {
        if (!selectedArea.IDLn) {
            toast.error("Area de Solicitud no seleccionada");
            return;
        }

        instanceArea.getIDBossByIDLnFunctionalID(selectedArea.IDLn, _single.getAccountID()).then(
            (resp) => {
                console.log(resp)
                if (resp.IDBoss) {

                    configProcedure?._pushInfo?.(
                        _single.jsonToBootstrapTable({
                            "Fecha de salida": `Desde: ${bean.FromDate} - Hasta: ${bean.UptoDate}`,
                            "Area": selectedArea.JsonCodeName,
                            "Sede": selectedArea.Name,
                            "¿Solicito Activos?": lengthList.fixed > 0 ? "Si" : "NO",
                            "¿Solicito Productos?": lengthList.product > 0 ? "Si" : "NO",
                            "Justificación": bean.Description,
                        })
                    );

                    if (configProcedure?._exportMap) {
                        configProcedure?._exportMap(bean)
                    }


                    if (configProcedure?._pushProps) {
                        configProcedure?._pushProps({ AssignTo: resp.IDBoss })
                    }

                } else {
                    toast.error("Jefe no Encontrado")
                }

            }
        ).catch(err => { toast.error(err) })



    }

    const sendData = () => {
        if (!validateForm()) {
            toast.error("Faltan campos obligatorios");
            return;
        }

        const newSign = {
            IDAccount: _single.getAccountID(),
            Approved: "true",
            Date: _single.getCurrenDate(),
        };



        instance.updateOutputAuthorizationRequest({ ...bean, JSONSignedApproveList: JSON.stringify([newSign]) }).then(
            (resp) => {
                configProcedure?._pushProps?.(resp);
                setBean(resp)
            }
        ).catch(err => {
            console.log(err);
            toast.error("No se pudo realizar la acción");
        });
    };

    const handleFixedChange = useCallback((e) => {
        setLengthList(prev => ({ ...prev, fixed: e }))
    }, []);

    const handleProductChange = useCallback((e) => {
        setLengthList(prev => ({ ...prev, product: e }))
    }, []);

    const steps: StepWizard[] = [
        {
            keyID: "0",
            name: 'PASO 1. Formulario',
            onEvent: () => { sendData() },
            children: <>
                <div className="row">
                    <div className="col-md-12">
                        {myGroups.length > 1 ?
                            <>
                                <label className={`${isMissing('IDWorkGroupMember') ? 'has-error' : ''}`}> Area de Solicitud</label>
                                <SelectIDWorkGroupBPMSingleton idSelector={bean.IDWorkGroupMember} onChange={(e) => { setSelectedArea(e); setBean({ ...bean, IDWorkGroupMember: e.IDWorkGroupMember, IDOffice: e.IDOffice, FunctionalIDLn: e.IDLn }) }} label=" " returnType="Object" />
                            </>
                            :
                            <>
                                <label className={`${isMissing('IDWorkGroupMember') ? 'has-error' : ''}`}> Area de Solicitud: {selectedArea?.Name} - {selectedArea?.JsonCodeName} </label>
                            </>
                        }
                    </div>
                    <div className="col-md-6">
                        <label className={`${isMissing('FromDate') ? 'has-error' : ''}`}>Fecha desde</label>
                        <InputDate name="" label=" " value={bean.FromDate} setDate={(e) => { setBean({ ...bean, FromDate: e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className={`${isMissing('UptoDate') ? 'has-error' : ''}`}>Fecha Hasta</label>
                        <InputDate name="" label=" " value={bean.UptoDate} setDate={(e) => { setBean({ ...bean, UptoDate: e }) }} />
                    </div>
                    <div className="col-md-12">
                        <label>Justificación</label>
                        <textarea value={bean.Description} className="form-control" onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                    </div>
                </div>
            </>,
            validButton: (bean.IDWorkGroupMember != null && bean.FromDate != null && bean.UptoDate != null),
            canReturn: false
        },
        {
            keyID: "1",
            name: 'PASO 2. Objetos a Retirar',
            onEvent: () => { onExportMap() },
            children: <SOLAUTOutputAuthorizationItem
                _IDOutputAuthorizationRequest={bean.IDOutputAuthorizationRequest}
                _onChangeFixed={handleFixedChange}
                _onChangeProduct={handleProductChange}
            />,
            validButton: (lengthList.fixed > 0 || lengthList.product > 0),
            canReturn: true,
            labelList: { labelNext: `Enviar Solicitud`, labelReturn: `Volver` }
        }
    ]

    return (
        <Wizard title="Solicitud de Autorización de Salida" listStep={steps} />
    );
}